/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const PatternIcon = ({ width = 24, height = 24, hidden = false, title = 'Pattern' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M2.75,19c-.41406,0-.75-.33594-.75-.75v-3c0-.41406.33594-.75.75-.75s.75.33594.75.75v3c0,.41406-.33594.75-.75.75Z"
      fill="currentColor"
    />
    <path
      d="M11.75,19c-.41406,0-.75-.33594-.75-.75v-3c0-.41406.33594-.75.75-.75s.75.33594.75.75v3c0,.41406-.33594.75-.75.75Z"
      fill="currentColor"
    />
    <path
      d="M8.75,17.5h-3c-.41406,0-.75-.33594-.75-.75s.33594-.75.75-.75h3c.41406,0,.75.33594.75.75s-.33594.75-.75.75Z"
      fill="currentColor"
    />
    <path
      d="M17.75,17.5h-3c-.41406,0-.75-.33594-.75-.75s.33594-.75.75-.75h3c.41406,0,.75.33594.75.75s-.33594.75-.75.75Z"
      fill="currentColor"
    />
    <path
      d="M17.25,14.5c-.41406,0-.75-.33594-.75-.75v-3c0-.41406.33594-.75.75-.75s.75.33594.75.75v3c0,.41406-.33594.75-.75.75Z"
      fill="currentColor"
    />
    <path
      d="M8.25,14.5c-.41406,0-.75-.33594-.75-.75v-3c0-.41406.33594-.75.75-.75s.75.33594.75.75v3c0,.41406-.33594.75-.75.75Z"
      fill="currentColor"
    />
    <path
      d="M14.25,13h-3c-.41406,0-.75-.33594-.75-.75s.33594-.75.75-.75h3c.41406,0,.75.33594.75.75s-.33594.75-.75.75Z"
      fill="currentColor"
    />
    <path
      d="M5.25,13h-3c-.41406,0-.75-.33594-.75-.75s.33594-.75.75-.75h3c.41406,0,.75.33594.75.75s-.33594.75-.75.75Z"
      fill="currentColor"
    />
    <path
      d="M2.75,10c-.41406,0-.75-.33594-.75-.75v-3c0-.41406.33594-.75.75-.75s.75.33594.75.75v3c0,.41406-.33594.75-.75.75Z"
      fill="currentColor"
    />
    <path
      d="M11.75,10c-.41406,0-.75-.33594-.75-.75v-3c0-.41406.33594-.75.75-.75s.75.33594.75.75v3c0,.41406-.33594.75-.75.75Z"
      fill="currentColor"
    />
    <path
      d="M8.75,8.5h-3c-.41406,0-.75-.33594-.75-.75s.33594-.75.75-.75h3c.41406,0,.75.33594.75.75s-.33594.75-.75.75Z"
      fill="currentColor"
    />
    <path
      d="M17.75,8.5h-3c-.41406,0-.75-.33594-.75-.75s.33594-.75.75-.75h3c.41406,0,.75.33594.75.75s-.33594.75-.75.75Z"
      fill="currentColor"
    />
    <path
      d="M17.25,5.5c-.41406,0-.75-.33594-.75-.75V1.75c0-.41406.33594-.75.75-.75s.75.33594.75.75v3c0,.41406-.33594.75-.75.75Z"
      fill="currentColor"
    />
    <path
      d="M8.25,5.5c-.41406,0-.75-.33594-.75-.75V1.75c0-.41406.33594-.75.75-.75s.75.33594.75.75v3c0,.41406-.33594.75-.75.75Z"
      fill="currentColor"
    />
    <path
      d="M14.25,4h-3c-.41406,0-.75-.33594-.75-.75s.33594-.75.75-.75h3c.41406,0,.75.33594.75.75s-.33594.75-.75.75Z"
      fill="currentColor"
    />
    <path
      d="M5.25,4h-3c-.41406,0-.75-.33594-.75-.75s.33594-.75.75-.75h3c.41406,0,.75.33594.75.75s-.33594.75-.75.75Z"
      fill="currentColor"
    />
  </svg>`;
};
